import { fetchApi } from "../../utils/fetchApis";

const homeURL = 'member/home';
const incompleteQueURL = 'member/profile/incomplete';
const questionnairesURL = 'member/getIncompleteQuestions';
const pdfURL = 'member/profile/download';
const saveAnswersURL = 'member/profile/answers';
const uploadAvatarURL = 'member/avatar/upload';
const uploadAudioURL = 'member/audio/upload';
const newViewMarkedURL = 'member/profile/hideNews'
const footprintMarkViewedURL = 'home/footPrintViewed'
const getAvatarURL = 'galleries/avatar';
const getAudioURL = 'audios';
const generateUserPinURL = 'member/generate/pin'
const msgCountUrl = 'member/header'


// export const fetchApi = async (url, method = 'GET', token_lang = {}, body = null, isJson = true, boolean=false) => {

export const getHomeDetails = (header) => fetchApi(homeURL, 'GET', header);

export const getAvatar = (header) => fetchApi(`${getAvatarURL}/${header.avatarId}`, 'GET', header, null, false, true);

export const getAudio = (header) => fetchApi(`${getAudioURL}/${header.audioId}`, 'GET', header, null, false, true);

export const getIncompleteQuetions = (header) => fetchApi(incompleteQueURL, 'GET', header);

export const incompleteQuestionnaires = (header) =>
  fetchApi(questionnairesURL, 'POST', header, {
    id: header.id,
    unAnsweredQuestions: header.questionsId,
  });

export const downloadPdf = (header) => fetchApi(`${pdfURL}/${header.type}`, 'GET', header, null, false, true);

export const saveAnswers = (header) => fetchApi(saveAnswersURL, 'POST', header, header.body);

export const uploadAvatar = (header) => fetchApi(`${uploadAvatarURL}/${header.category}`, 'POST', header, header.form, false, true);

export const uploadAudio = (header) => fetchApi(`${uploadAudioURL}/${header.category}`, 'POST', header, header.form, false, true);

export const newsViewMarked = (header, newsid) => fetchApi(`${newViewMarkedURL}/${newsid}`, 'PUT', header, null, false, true);

export const footprintMarkViewed = (header, relationshipId) => fetchApi(`${footprintMarkViewedURL}/${relationshipId}`, 'PUT', header, null, false, true);

export const generateUserPin = (header) => fetchApi(generateUserPinURL, 'GET', header);

export const getMessageCount = (header) => fetchApi(msgCountUrl, 'GET', header);





